<script setup lang="ts">
import CommonBtn from '@/components/common-btn/CommonBtn.vue'
import { Collection, Coordinate, Files, Guide, ShoppingBag } from '@element-plus/icons-vue'


const footerBarData = [
  {
    icon: ShoppingBag,
    name: '商城',
    path: 'Mall'
  },
  {
    icon: Coordinate,
    name: '对战',
    path: 'Duel',
  },
  {
    icon: Guide,
    name: '冒险',
    path: 'Dungeon',
  },
  {
    icon: Files,
    name: '卡组',
    path: 'Deck',
  },
  {
    icon: Collection,
    name: '天赋',
    path: 'Skill',
    hidden: true
  },
]
const props = withDefaults(defineProps<{
  modelValue?: string
}>(), {
  modelValue: 'Duel'
})
const emits = defineEmits(['update:modelValue'])
</script>

<template>
  <div class="footer-bar-wrap">
    <div class="footer-bar">
      <div class="item" v-for="item of footerBarData.filter((item) => !item.hidden)" :key="item.name">
        <CommonBtn :plain="item.path !== props.modelValue" @done="emits('update:modelValue', item.path)">
          <el-icon size="24px">
            <component :is="item.icon"></component>
          </el-icon>
          <span>{{ item.name }}</span>
        </CommonBtn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-bar-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;

  .footer-bar {
    display: flex;
    max-width: $maxWidth;
    margin: 0 auto;
    justify-content: space-around;
    background-color: var(--backColor);

    .item {
      width: 20%;
      text-align: center;

      span {
        font-size: 16px;
        margin-left: 0;
      }
    }
  }
}
</style>
